export default "__VITE_ASSET__C$crDhIz__"